import {clsx} from 'clsx'
import {useState} from 'react'

import {ChevronDownIcon} from '@primer/octicons-react'
import {Stack, Text} from '@primer/react-brand/esm'

import type {CopilotFeature} from '../../../../../../brand/lib/types/contentful'
import {
  PLAN_TYPES,
  type PlanType,
} from '../../../../../../brand/components/PlanTypeSegmentedControl/PlanTypeSegmentedControl'

import {CompareTableRow} from '../CompareTableRow/CompareTableRow'

import styles from './styles.module.css'

type Props = {
  heading: string
  rows: CopilotFeature[]
  planType: PlanType
  htmlId?: string
}

export function CompareTableGroup(props: Props) {
  const {heading, rows, planType, htmlId} = props

  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <Stack role="rowgroup" direction="vertical" gap="none" padding="none" id={htmlId}>
      <div role="row">
        <div role="cell" className={styles.heading}>
          <Text size="300" weight="medium">
            {heading}
          </Text>
        </div>

        <div role="cell" className={styles.toggleCell}>
          <button
            type="button"
            aria-expanded={isExpanded}
            className={styles.toggle}
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <Text size="300" weight="semibold" className={styles.label}>
              {heading}

              <div className={styles.icon}>
                <ChevronDownIcon />
              </div>
            </Text>
          </button>
        </div>
      </div>

      <div className={clsx(styles.features, isExpanded && styles.expanded)}>
        {rows.map(row => (
          <CompareTableRow
            key={row.sys.id}
            contentfulContent={row}
            showFree={planType === PLAN_TYPES.Individual}
            showPro={planType === PLAN_TYPES.Individual}
            showProPlus={planType === PLAN_TYPES.Individual}
            showMax={planType === PLAN_TYPES.Individual}
            showBusiness={planType === PLAN_TYPES.Business}
            showEnterprise={planType === PLAN_TYPES.Business}
          />
        ))}
      </div>
    </Stack>
  )
}
